import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';
import { flex } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    overlay: {
        display: 'none',
        [theme.phoneLandscape]: {
            ...flex('column', 'center', 'center'),
            position: 'fixed',
            inset: 0,
            zIndex: 20000,
            padding: theme.spacing(6),
            textAlign: 'center',
            gap: theme.spacing(4),
            backgroundColor: theme.colors.violet_darkest,
            backgroundImage: 'linear-gradient(135deg, #1a1235 0%, #0e0e1c 100%)',
            color: '#ffffff',
        },
    },
    icon: {
        fontSize: 48,
        color: '#ffffff',
    },
    title: {
        fontFamily: theme.font.primary,
        fontSize: 20,
        fontWeight: 700,
        margin: 0,
    },
    text: {
        fontFamily: theme.font.secondary,
        fontSize: 14,
        lineHeight: 1.4,
        maxWidth: 360,
        opacity: 0.85,
        margin: 0,
    },
}));
